var map = {
	"./logo1.png": "06e9",
	"./logo10.png": "941a",
	"./logo11.png": "b7ab",
	"./logo12.png": "0fd8",
	"./logo13.png": "3727",
	"./logo14.png": "01a3",
	"./logo15.png": "584f",
	"./logo2.png": "3d0a",
	"./logo3.png": "de2f",
	"./logo4.png": "d8ca",
	"./logo5.png": "fe0c",
	"./logo6.png": "8525",
	"./logo7.png": "4581",
	"./logo8.png": "08d3",
	"./logo9.png": "09df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5822";